import { render, staticRenderFns } from "./copyInsert.vue?vue&type=template&id=adf6a3fe&scoped=true"
import script from "./copyInsert.vue?vue&type=script&lang=js"
export * from "./copyInsert.vue?vue&type=script&lang=js"
import style0 from "./copyInsert.vue?vue&type=style&index=0&id=adf6a3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf6a3fe",
  null
  
)

export default component.exports